import ParserBase from "./parser-base";
import ValueMapper from "../common/value-mapper";

/**
 * 水揚げ情報を表示情報に変換する
 */
class Unloading extends ParserBase {
  /**
   * 採取海域区分を表示データに変換する
   */
  parseHarvestSeaArea(value) {
    return ValueMapper.map({
      1: "広島湾西部",
      2: "広島湾北部",
      3: "広島湾中部",
      4: "広島湾南部",
      5: "呉湾",
      6: "広湾",
      7: "三津湾",
      8: "広島県東部",
    }).getOrElse(value, "-");
  }

  /**
   * 漁業権番号を表示データに変換する
   */
  parseUnloadingRightsNumbers(values) {
    return ValueMapper.join(
      values.map((value) => {
        const { number, name } = value.unloading_rights_number;
        return `${number} ${name}`;
      }),
      "<br />"
    ).getOrElse("-");
  }

  /**
   * 海域区分を表示データに変換する
   */
  parseClassification(values) {
    let classification = "";
    let specCnt = 0;
    let condCnt = 0;
    let notSpecCnt = 0;
    // 海域区分の情報作成
    for ( const value of values ){
      switch (value.unloading_rights_number.classification) {
        case 1: // 指定
          specCnt++;
          break;
        case 2: // 条件付き指定
          condCnt++;
          break;
        case 3: // 指定外
          notSpecCnt++;
          break;
        default:
          break;
      }
    }
    // 海域区分文字列構築
    if (specCnt != 0) {
      classification += "指定/";
    }
    if (condCnt != 0) {
      classification += "条件付き指定/";
    }
    if (notSpecCnt != 0) {
      classification += "指定外/";
    }
    classification = classification.slice(0, -1);

    return classification;
  }

  /**
   * 食用途を表示データに変換する
   */
  parseEatUse(valueRaw, valueHeating) {
    return ValueMapper.join(
      [
        { value: "生食用", condition: valueRaw },
        { value: "加熱用", condition: valueHeating },
      ],
      "<br />"
    ).getOrElse("-");
  }

  /**
   * 水揚げ量を表示データに変換する
   */
  parseAmount(amount1, amount2) {
    if(amount1 != -1 && amount2 != -1) {
      return `${amount1 * amount2}枚`;
    } else {
      return `-枚`;
    }
  }

  /**
   * 受信したHACCP情報を表示データに変換する
   * @param {受信したHACCP情報} data
   * @returns 表示データ
   */
  contentsParse(data) {
    return [
      {
        title: "採取海域区分",
        message: this.parseHarvestSeaArea(data.harvest_sea_area),
      },
      {
        title: "区画漁業権番号",
        message: this.parseUnloadingRightsNumbers(
          data.unloading_rights_numbers
        ),
      },
      {
        title: "海域区分",
        message: this.parseClassification(data.unloading_rights_numbers),
      },
      {
        title: "人工浄化",
        message: ValueMapper.map({
          false: "未実施",
          true: "実施",
        }).getOrElse(data.purification, "-"),
      },
      {
        title: "ノロウィルス検査結果",
        message: ValueMapper.map({
          false: "陰性",
          true: "陽性",
        }).getOrElse(data.norovirus, "-"),
      },
      {
        title: "食用途",
        message: this.parseEatUse(data.eat_use_raw, data.eat_use_heating),
      },
      {
        title: "貝毒検査結果",
        message: ValueMapper.map({
          1: "2MU以下",
          2: "2～4MU",
          3: "4MU以上",
        }).getOrElse(data.poison, "-"),
      },
      {
        title: "水揚げ量",
        message: this.parseAmount(data.amount1, data.amount2),
      },
    ];
  }
}

export default new Unloading({
  type: "object",
  properties: {
    type: { type: "string", enum: ["UNLOADING"] },
    date: { type: "string", format: "date" },
    harvest_sea_area: { type: "number", enum: [1, 2, 3, 4, 5, 6, 7, 8] },
    unloading_rights_numbers: {
      type: "array",
      items: {
        type: "object",
        properties: {
          unloading_rights_number: {
            type: "object",
            properties: {
              number: { type: "string" },
              name: { type: "string" },
              classification: { type: "number", enum: [1, 2, 3] },
            },
            required: ["number", "name", "classification"],
          },
        },
        required: ["unloading_rights_number"],
      },
    },
    purification: { type: "boolean" },
    norovirus: { type: "boolean" },
    poison: { type: "number", enum: [1, 2, 3] },
    eat_use_raw: { type: "boolean" },
    eat_use_heating: { type: "boolean" },
    amount1: { type: "number" },
    amount2: { type: "number" },
  },
  required: [
    "type",
    "date",
    "harvest_sea_area",
    "unloading_rights_numbers",
    "purification",
    "norovirus",
    "poison",
    "eat_use_raw",
    "eat_use_heating",
    "amount1",
    "amount2",
  ],
});
